// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iWOOq","maxWidthContainer":"styles_maxWidthContainer__CnoHZ","about":"styles_about__hnVMs","aboutText":"styles_aboutText__R6KRO"};